import React from 'react';
import { View, TouchableWithoutFeedback, Animated } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { AnimatedVFText } from '@vfgroup-oneplatform/foundation/Components';

import FrameworkTestKeys from '../../../../FrameworkTestKeys';
import { Images } from '../../../../Themes';
import Badge from '../Badge/Badge';

import styles from './Tab.Styles';

function getIconStyle(size) {
  return { width: size, height: size };
}

function renderTrayIcon({ trayIcon, size, customStyle, iconAnimation, accessibilityLabelIcon }) {
  return (
    trayIcon || (
      <Animated.Image
        accessibilityLabel={accessibilityLabelIcon}
        source={Images.toBi}
        style={[getIconStyle(size), customStyle, iconAnimation]}
        testID={FrameworkTestKeys.trayTabAnimatedImage}
      />
    )
  );
}

const Tab = ({
  tabStyles,
  trayIcon,
  icon,
  title,
  customContainerStyle,
  customStyle,
  size,
  tabAnimation,
  isVisible,
  notification,
  onPress,
  numberOfLines,
  accessibilityLabel,
  accessibilityLabelIcon,
  trayPlaceHolders,
  withTrayIcon,
}) => {
  const { title: titleAnimation, icon: iconAnimation } = tabAnimation || {};
  const { title: titleStyle, icon: iconStyle } = tabStyles || {};
  return (
    <TouchableWithoutFeedback
      onPress={onPress}
      accessibilityLabel={accessibilityLabel}
      testID={FrameworkTestKeys.trayTabTWF}
    >
      <View
        style={[styles.container, customContainerStyle]}
        accessibilityLabel={accessibilityLabel}
        testID={FrameworkTestKeys.trayTabView}
      >
        <View style={styles.trayIconContainer} testID={FrameworkTestKeys.trayTabIconView}>
          {withTrayIcon &&
            renderTrayIcon({
              trayIcon,
              size,
              customStyle,
              iconAnimation,
              accessibilityLabelIcon,
            })}
        </View>
        <View style={styles.iconContainer} testID={FrameworkTestKeys.trayTabIconContainerView}>
          <Animated.Image
            accessibilityLabel={accessibilityLabelIcon}
            source={icon}
            style={[getIconStyle(size), customStyle, iconAnimation, iconStyle]}
            testID={FrameworkTestKeys.trayTabIconContainerAnimatedImage}
          />
          {!isVisible && notification ? (
            <Badge
              text={JSON.stringify(notification)}
              containerStyle={styles.badgeStyle(notification)}
            />
          ) : null}
        </View>
        {!!title && (
          <AnimatedVFText
            i18nKey={title}
            placeHolders={trayPlaceHolders && trayPlaceHolders[title]}
            accessibilityLabel={accessibilityLabel}
            style={[styles.title, titleAnimation, titleStyle]}
            numberOfLines={numberOfLines}
            ellipsizeMode={'tail'}
            testKey={FrameworkTestKeys.trayTabIconContainerTitle}
          />
        )}
      </View>
    </TouchableWithoutFeedback>
  );
};
Tab.defaultProps = {
  size: 28,
  numberOfLines: 1,
  tabAnimation: {},
};

Tab.propTypes = {
  icon: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.shape({ uri: PropTypes.string.isRequired }),
  ]),
  title: PropTypes.string,
  tabStyles: PropTypes.shape({
    title: TextPropTypes.style,
    icon: ViewPropTypes.style,
  }),
  customContainerStyle: ViewPropTypes.style,
  customStyle: ViewPropTypes.style,
  size: PropTypes.number,
  tabAnimation: PropTypes.shape({
    title: PropTypes.object,
    icon: PropTypes.object,
  }),
  isVisible: PropTypes.bool,
  notification: PropTypes.number,
  onPress: PropTypes.func,
  numberOfLines: PropTypes.number,
  accessibilityLabel: PropTypes.string,
  accessibilityLabelIcon: PropTypes.string,
  trayIcon: PropTypes.element,
  trayPlaceHolders: PropTypes.object,
  withTrayIcon: PropTypes.bool,
};

export default Tab;
